<template>
    <div class="login-form-home text-align-left">
        <div class="login-form-wrapper">
          <div class="bp-logo">
              <img src="@/assets/images/logos/BP.png" alt="logo">
              <p class="app-name">{{ $t('OUTER_PAGES.common.player')}}</p>
              <div class="logo-text">{{ $t('OUTER_PAGES.common.subheading')}}</div>
          </div>
          <form v-loading-form="loadingForm" class="form" name="loginForm" novalidate @submit.prevent="onLoginFormSubmitted">
              <div class="text-center loginForm loginForm-default">
                <div class="error-wrapper-table">
                  <div class="error-wrapper">
                      <div class="error server-error" v-if="serverErrors">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ $t('OUTER_PAGES.loginPage.otherError')}}
                      </div>
                      <div class="error server-error" v-if="notRegistered">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ $t('OUTER_PAGES.loginPage.notRegistered')}}
                      </div>
                      <div class="error server-error" v-if="incorrectPass && formSubmitted">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ $t('OUTER_PAGES.loginPage.incorectPass')}}
                      </div>
                      <div class="error" v-show="(errors.has('email') && formSubmitted)">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ errors.first('email') }}
                      </div>
                      <div class="error" v-show="(errors.has('password') && formSubmitted)">
                        <img src="@/assets/images/icons/error-icon.png" alt="error">
                        {{ errors.first('password') }}
                      </div>
                  </div>
                </div>
                <div class="form-group inputLogin">
                    <input
                      id="email"
                      :class="{'error-input': (errors.has('email') && formSubmitted)}"
                      @input="serverErrors = false"
                      type="email"
                      class="form-control"
                      :placeholder="$t('OUTER_PAGES.loginPage.email')"
                      name="email"
                      v-model="email"
                      v-validate="'required|email'">
                    <input
                      id="password"
                      type="password"
                      :class="{'error-input': (errors.has('password') && formSubmitted)}"
                      class="form-control"
                      :placeholder="$t('OUTER_PAGES.loginPage.password')"
                      v-model="password"
                      v-validate="'required|min:8|max:50'"
                      name="password">
                </div>
              </div>
              <div class="text-center loginStructure">
                <button type="submit" class="btn buttonOnLogin btn-type-1">
                  <span class="button-content">{{ $t('OUTER_PAGES.loginPage.signIn')}}</span>
                </button>
                <router-link class="login-link" :to="{ name: 'ForgottenPassword' }" @click.native="logForgotPass">{{ $t('OUTER_PAGES.loginPage.forgotPass')}}</router-link>
              </div>
          </form>
        </div>
    </div>
</template>

<script>
import { LOGIN } from '@/store/action.types'
import STATUS_CODES from '@/common/statusCodes'
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      serverErrors: false,
      formSubmitted: false,
      loadingForm: false,
      notRegistered: false,
      incorrectPass : false
    }
  },
  methods: {
    ...mapActions({
      loginAction: LOGIN
    }),
    onLoginFormSubmitted () {
      this.$amplitude.logEvent('pwa: submit login form')
      this.$validator.validateAll().then(result => {
        this.loadingForm = true
        this.formSubmitted = true
        if (result) {
          this.loginAction({
            email: this.email,
            password: this.password
          })
            .then(() => {
              const redirectToRoute = this.$route.query.redirectTo
              this.serverErrors = false
              if (redirectToRoute) {
                this.$router.push(redirectToRoute)
              } else {
                this.$router.push('/')
              }
              this.loadingForm = false
            })
            .catch((error) => {
              if (error.status.code === STATUS_CODES.BP_404) {
                this.notRegistered = true;
              } else if (error.status.code === STATUS_CODES.BP_400 && error.data === null) {
                this.incorrectPass = true;
              } else {
                this.serverErrors = true
                this.incorrectPass = false;
                this.notRegistered = false;
              }
              this.loadingForm = false;
            })
        } else {
          this.loadingForm = false
        }
      })
    },
    logForgotPass() {
      this.$amplitude.logEvent('pwa: click on forgot password')
    }
  }
}
</script>
